<app-header></app-header>

<app-loader *ngIf="showLoader"> </app-loader>

<div class="container main-page" *ngIf="!showLoader">
  <div class="container">
    <div class="row">
      <div class="col-md-4">
        <div class="form-control">
          <label>
            Product Id
          </label>
          <input
            class="p5-px ml-5"
            type="text"
            [(ngModel)]="selectedproductId"
            placeholder=""
          />
        </div>
      </div>

      <div class="col-md-4">
        <div class="form-control">
          <label>Type</label>

          <app-drop-down-single-select
            [name]="'productType'"
            [DropDownOptions]="listProductType"
            (typeSelectedChanged)="updateSelectedDropDown($event)"
            class="ml-5"
          ></app-drop-down-single-select>
        </div>
      </div>

      <div class="col-md-4">
        <div class="form-control">
          <label>Book Type</label>

          <app-drop-down-single-select
            [name]="'bookType'"
            [DropDownOptions]="listBookType"
            (typeSelectedChanged)="updateSelectedDropDown($event)"
            class="ml-5"
          ></app-drop-down-single-select>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="row"></div>
  </div>
  <div>
    <br />
  </div>

  <div class="container">
    <div class="d-grid gap-2 d-md-flex justify-content-md-end">
      <button
        type="submit"
        class="btn btn-pkt search-btn btn-primary ol-btn"
        (click)="searchProduct()"
      >
        Search
        <i class="bi bi-search ps-1"></i>
      </button>

      <button class="btn btn-pkt btn-secondary ms-1" (click)="clearFilters()">
        Reset
        <i class="bi bi-trash ps-1"></i>
      </button>
    </div>
  </div>
  <app-search-note></app-search-note>
  <div class="container contain contain table-responsive">
    <table
      style="width: 950px; overflow-x: scroll;"
      class="table table-hover table-bordered table-striped mt-2 pkt-table-style"
    >
      <thead class="thead-dark">
        <tr>
          <th scope="col" style="width: 10%;">Product ID</th>
          <th scope="col" style="width: 15%;">Title</th>
          <th scope="col" style="width: 10%;">Book Type</th>
          <th scope="col" style="width: 20%;">PPD</th>

          <th scope="col" style="width: 20%;">Published Date/OSD</th>
          <th scope="col" style="width: 15%;">Product Status</th>
          <th scope="col" style="width: 15%;">PI Status</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let product of Products;">
          <!-- <th scope="row"><input (change)="getCheckboxValues($event,product)" type="checkbox"></th> -->
          <th scope="row" class="font-14px">
            <a
              href="{{apiURL}}/#/products/record/{{product.id}}"
              target="_blank"
              >{{product.part_number}}</a
            >
          </th>
          <td class="font-14px">{{product.name}}</td>
          <td class="font-14px">{{product.book_type}}</td>
          <td class="font-14px">
            <app-date
              [product]="product"
              type="ppd"
              [inputDate]="product?.ppd"
              (dateSelected)="updateIepd($event)"
              [productId]="product.id"
            ></app-date>
          </td>

          <td class="font-14px">
            <app-date
              [product]="product"
              type="publishingDate"
              [inputDate]="product?.publishing_date"
              (dateSelected)="updateIepd($event)"
              [productId]="product.id"
            ></app-date>
          </td>

          <td class="font-14px">
            <app-status-drop-down
              [productId]="product.id"
              type="status"
              [inputList]="ProductStatusList.data"
              [currentStatus]="product.status_id"
              (statusSelected)="updateStatus($event)"
            ></app-status-drop-down>
          </td>
          <td class="font-14px">
            <app-pistatus-drop-down
              [productId]="product.id"
              type="pistatus"
              [inputList]="piProductStatusList"
              [currentStatus]="product.pistatus"
              (statusSelected)="updatePiStatus($event)"
            ></app-pistatus-drop-down>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <ng-template #mymodal let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Confirmation</h4>
      <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="modal.dismiss('Cross click')"
      >
        <span aria-hidden="true">×</span>
      </button>
    </div>
    <div class="modal-body">
      Are you sure you want to save this change?
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-danger"
        (click)="modal.dismiss('cancel')"
      >
        Cancel
      </button>
      <button
        type="button"
        class="btn btn-success"
        (click)="modal.dismiss('save')"
      >
        Save
      </button>
    </div>
  </ng-template>

  <ngb-toast
    class="toast-container position-fixed top-0 end-0 p-3"
    style="z-index: 1200;"
    *ngIf="processingToastShow"
    [autohide]="false"
    (hidden)="processingToastShow=false"
  >
    Processing your request...
  </ngb-toast>

  <ngb-toast
    class="toast-container position-fixed top-0 end-0 p-3"
    style="z-index: 1200; background-color: #198754; color: aliceblue;"
    *ngIf="successToastShow"
    [autohide]="true"
    (hidden)="successToastShow=false"
  >
    Request successfully processed!
  </ngb-toast>
</div>
